
import Splash from "../Pages/Splash";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import Home from "../Pages/Tracking/Home";
import TrackingHistory from "../Pages/Tracking/TrackingHistory";
import Subscription from "../Pages/Tracking/Subscription";


const appRoutes = [
    {
        pageId : 0,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 4,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 5,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 5,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 6,
        path: "/tracking-history/:id",
        component: <TrackingHistory />,
    },
    {
        pageId : 6,
        path: "/subscription/:car",
        component: <Subscription />,
    },

];
export default appRoutes;